export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9064.b0372d63.jpg";